<template>
    <div class="py-2">
        <div class="px-4 py-2" :class="{ 'input-has-error': hasNameError }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="first_name" class="text-sm">Full Name</label>
                </div>
            </div>
            <div class="flex mb-1">
                <div class="flex-auto pr-1">
                    <input type="text"
                        id="first_name"
                        name="first_name"
                        placeholder="First"
                        class="input-field w-full bg-gray-100"
                        :value="first_name"
                        readonly />
                </div>
                <div class="flex-auto pl-1">
                    <input type="text"
                           id="middle_name"
                           name="middle_name"
                           placeholder="Middle"
                           class="input-field w-full bg-gray-100"
                           :value="middle_name"
                           readonly />
                </div>
            </div>
            <input type="text"
                id="last_name"
                name="last_name"
                placeholder="Last Name"
                class="input-field w-full bg-gray-100"
                :value="last_name"
                readonly />
        </div>
        <div class="px-4 py-2" :class="{ 'input-has-error': errors && errors.hasOwnProperty('email') }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="email" class="text-sm">Email</label>
                </div>
                <div v-if="errors && errors.hasOwnProperty('email')" class="flex-initial text-right">
                    {{ errors['email'].join(', ') }}
                </div>
            </div>
            <input type="text"
                id="email"
                name="email"
                placeholder="you@somewhere.com"
                class="input-field w-full"
                :class="{ 'bg-gray-100': !canChangeEmail }"
                :value="email"
                @input="$emit('update:email', $event.target.value)" 
                :readonly="!canChangeEmail"
                />
        </div>
        <div class="px-4 py-2" :class="{ 'input-has-error': errors && errors.hasOwnProperty('password') }">
            <div class="flex justify-between mb-3.5">
                <div class="flex-initial">
                    <label for="password" class="text-sm">Change Password</label>
                </div>
                <div v-if="errors && errors.hasOwnProperty('password')" class="flex-initial">
                    {{ errors['password'].join(', ') }}
                </div>
            </div>
            <div class="flex mb-1">
                <div class="flex-auto pr-1">
                    <input type="password"
                           id="password"
                           name="password"
                           placeholder="*******"
                           class="input-field w-full"
                           @input="$emit('update:password', $event.target.value)" />
                </div>
                <div class="flex-auto pl-1">
                    <input type="password"
                           id="password_confirmation"
                           name="password_confirmation"
                           placeholder="*******"
                           class="input-field w-full"
                           @input="$emit('update:password_confirmation', $event.target.value)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'first_name',
            'middle_name',
            'last_name',
            'email',
            'errors',
            'canChangeEmail',
            'hasNameError'
        ],
    }
</script>